import {Card, CardBody, CardHeader, Typography} from "@material-tailwind/react";
import React, {useCallback, useEffect, useState} from "react";
import {AdminWithdrawalGrid} from "./admin_grid";
import {AdminWithdrawalForm} from "./admin_form";
import {WithdrawalSourcesModal} from "./sources_modal";
import {getWithdrawalReport} from "../../services/report/withdrawal";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import {downloadFile} from "../../config";
import {PaginateContext} from "../../context/paginate";
import {AdminWithdrawalFilter} from "./admin_filter";

export function AdminWithdrawalManagement() {

  const [withdrawals, setWithdrawals] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [sourcesModalOpen, setSourcesModalOpen] = useState(false);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  const [personId, setPersonId] = useState(null);
  const [minValue, setMinValue] = useState(null);
  const [maxValue, setMaxValue] = useState(null);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getWithdrawalReport(paginate);
    if (result.status === 200) {
      const {withdrawalList, total_count} = result.data;
      setWithdrawals(withdrawalList || []);
      setGridTotalRowCount(total_count);
    }
  }

  const filter = useCallback(() => {
    const filterParams = {}

    if (personId) {
      filterParams["person_id"] = personId
    }

    if (minValue) {
      filterParams["min_value"] = minValue
    }

    if (maxValue) {
      filterParams["max_value"] = maxValue
    }

    if (dateFrom) {
      filterParams["date_from"] = dateFrom
    }

    if (dateTo) {
      filterParams["date_to"] = dateTo
    }

    if (status) {
      filterParams["status"] = status
    }

    return filterParams;
  }, [personId, minValue, maxValue, dateFrom, dateTo, status])

  useEffect(() => {
    // const data = filter()
    const paginateParams = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    })

    const params = filter();
    const filterParams = new URLSearchParams(params);

    for (const [key, value] of filterParams.entries()) {
      paginateParams.append(key, value);
    }

    const paginate = paginateParams.toString()

    getData(paginate)
  }, [filter, lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

  const clearFilters = () => {
    setPersonId(null);
    setMinValue(null);
    setMaxValue(null);
    setDateFrom("");
    setDateTo("");
    setStatus("");
  };

  const exportReport = () => {
    downloadFile("withdrawal_report_excel", filter(), "withdrawals");
  };

  return (
    <PaginateContext.Provider value={{
      setSortBy: setSortBy,
      sortType: sortType,
      setSortType: setSortType,
      active: gridCurrentPage,
      setActive: setGridCurrentPage,
      totalRows: gridTotalRowCount,
      rowsCount: gridRowCount,
      setRowsCount: setGridRowCount,
      from: from,
      to: to,
    }}>
      <div className="flex w-full flex-col gap-4 p-4">
        <Card className="w-full">
          <CardHeader
            floated={false}
            shadow={false}
            className="m-0 w-full rounded-none bg-transparent px-6 pt-6"
          >
            <div className="flex items-center justify-between gap-8">
              <Typography variant="h5" color="blue-gray">
                درخواست‌های برداشت
              </Typography>
            </div>
          </CardHeader>

          {sourcesModalOpen && (
            <WithdrawalSourcesModal
              withdrawal={gridSelectedRow}
              open={sourcesModalOpen}
              setOpen={setSourcesModalOpen}
            />
          )}

          <CardBody>
            <AdminWithdrawalFilter
              personId={personId}
              setPersonId={setPersonId}
              status={status}
              setStatus={setStatus}
              minValue={minValue}
              setMinValue={setMinValue}
              maxValue={maxValue}
              setMaxValue={setMaxValue}
              dateFrom={dateFrom}
              setDateFrom={setDateFrom}
              dateTo={dateTo}
              setDateTo={setDateTo}
              hasRows={withdrawals.length > 0}
              onClear={clearFilters}
              onExport={exportReport}
              onOpenSources={() => setSourcesModalOpen(true)}
              sourcesDisabled={!gridSelectedRow || !(gridSelectedRow.sources && gridSelectedRow.sources.length > 0)}
            />
          </CardBody>
        </Card>

        <Card className="w-full">
          <CardBody className="w-full overflow-x-auto p-0">
            <div className="relative">
              <AdminWithdrawalGrid
                withdrawals={withdrawals}
                setModalOpen={setModalOpen}
                setSelectedRow={setGridSelectedRow}
              />
            </div>
          </CardBody>

          <CardFooterPaginator/>
        </Card>
      </div>

      {modalOpen && (
        <AdminWithdrawalForm
          withdrawal={gridSelectedRow}
          open={modalOpen}
          setOpen={setModalOpen}
          setLastDataRefresh={setLastDataRefresh}
          setGridSelectedRow={setGridSelectedRow}
        />
      )}
    </PaginateContext.Provider>
  );
}
